import { render, staticRenderFns } from "./fp_layout.vue?vue&type=template&id=3139e346"
import script from "./fp_layout.vue?vue&type=script&lang=js"
export * from "./fp_layout.vue?vue&type=script&lang=js"
import style0 from "./fp_layout.vue?vue&type=style&index=0&id=3139e346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports